module.exports = __webpack_public_path__ + "img/login.d6d3bb09.jpg";